<template>
  <transition enter-active-class="loading">
    <div id="dark-mode">
      <loading-page v-if="isLoading" />
      <router-view />
    </div>
  </transition>
</template>

<script setup>
//import 
import { computed, watch, watchEffect, nextTick } from 'vue';
import { useRoute } from "vue-router";
import store from './store';

//component
import LoadingPage from './components/LoadingPage.vue';

//data
const darkMode = computed(() => {
  return store.getters.getDarkMode;
});
const isLoading = computed(() => {
  return store.getters.getLoading;
});


const defaultTitle = "سامانه انبارداری";
const route = useRoute();


//watchers
watchEffect(() => {
  nextTick(() => {
    document.title = route.meta.title || defaultTitle;
  });
});

watch(darkMode, () => {
  const darkModeItem = document.querySelector("#dark-mode")
  if (darkMode.value)
    darkModeItem.classList.add("dark");
  else
    darkModeItem.classList.remove("dark");
})
</script>
<style lang="scss">
@import "./assets/scss/fontFaces.scss";

:root {
  --color: #caa306;
}

* {
  direction: rtl;
  font-family: 'Vazirmatn';
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}

.loading {
  animation: animation 1s ease;
}

@keyframes animation {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

input:focus,
select:focus,
textarea:focus,
button:focus {
  outline: none;
}

.vpd-next,
.vpd-prev,
.vpd-year-label {
  display: flex;
  align-items: center;
  justify-content: center;
}

.vpd-content {
  border-radius: 10px;
  overflow: hidden;
}

.vpd-time .vpd-down-arrow-btn,
.vpd-time .vpd-up-arrow-btn {
  display: flex !important;
  justify-content: center;
}

@media print {
  #toast-container,
  .Toastify,
  .vue3-toastify {
    display: none !important;
  }
}
</style>
